<template>
  <div>
    <v-card flat class="ma-auto text-center">
      <p class="display-1 font-weight-bold">{{title}}</p>
      <p class="subtitle-1 font-weight-bold">{{message}}</p>
    </v-card>
  </div>
</template>



<script>
export default {
  data() {
    return {
      status: null
    };
  },
  computed: {
    title() {
      if (this.status == 404) {
        return "Page not found!";
      } else if (this.status == 403) {
        return "Access denied!";
      }
    },
    message() {
      if (this.status == 404) {
        return "This page could not be found.";
      } else if (this.status == 403) {
        return "You don't have the right permission to do that.";
      }
    }
  },
  created() {
    this.status = this.$route.params.status;
  }
};
</script>



// WEBPACK FOOTER //
// src/views/error/Error.vue